jQuery(function ($) {
    function resizeHeadings(container, element, breakpoint = 780) {
        var mh = 0;
        var combo = container + ' ' + element;
        // console.log(combo);

        $(combo).css('min-height', '0');
        if ($(window).outerWidth() >= breakpoint) {
            $(container).find(element).each(function () {

                if ($(this).outerHeight() > mh) { mh = $(this).outerHeight() }
            })
        }
        $(combo).css('min-height', mh);
    }

    if ($('.teaser-container')) {
        $('.teaser-container').each( function () {
        // resizeMatchHeights('.boxshadow-icon-container');
        window.addEventListener("load", function() {
            resizeMatchHeights('h2', '.teaser-container');
            
        });
        window.addEventListener('resize', function () {
            if ($(window).width() > 780) {
                resizeMatchHeights('h2', '.teaser-container');
            } else {
                resizeMatchHeights('h2', '.teaser-container');
            }
        });
    });
}
    function resizeMatchHeights(selector, container = null, unset = false, breakpoint = 780) {
        var heightHolder = 0;
        $(selector).css('min-height', '0');
        if (container == null) {
             
            if (unset == false) {
                $(selector).each(function () {
                    if ($(this).innerHeight() > heightHolder) {
                        heightHolder = $(this).innerHeight();
                    }
                });
                $(selector).css('min-height', heightHolder + 'px');
            }

        } else {
            $(container).each(function(){
                var heightHolder = 0;
                if (unset == false) {
                    $(this).find(selector).each(function () {
                        console.log(container, $(this).innerHeight());
                        if ($(this).innerHeight() > heightHolder) {
                            heightHolder = $(this).innerHeight();
                        }
                    });
                    $(this).find(selector).css('min-height', heightHolder + 'px');
                }
             });
        }
    }
    // if ($('.blog-archive__posts').length > 0) {
    //     resizeHeadings('.blog-archive__posts', 'h2', 576);
    //     $(window).on('resize', function () { resizeHeadings('.blog-archive__posts', 'h2', 576) });

    //     resizeHeadings('.blog-archive__posts', '.excerpt', 576);
    //     $(window).on('resize', function () { resizeHeadings('.blog-archive__posts', '.excerpt', 576) });
    // }

});
